import EntityProfileCaregiverRelationshipsSection from "../../../../entityProfileModal/sections/caregiverRelationships/EntityProfileCaregiverRelationshipsSection";
import { getRelatedEntityId } from "../../../../entityProfileModal/sections/caregiverRelationships/caregiverRelationships.utils";
import type { CaregiverId } from "../../../../../shared/schema/schema";
import type { CaregiverProfileBridgeActions } from "../../../caregiverProfileModal.actions";
import type { CaregiverProfileCaregiver } from "../../../caregiverProfileModal.types";
import { getCaregiverFullName } from "../../../caregiverProfileModal.utils";

type Props = {
  actions: CaregiverProfileBridgeActions;
  caregiver?: CaregiverProfileCaregiver;
  caregiverId: CaregiverId;
};

export default function CaregiverProfilePatientRelationshipsSection(props: Props) {
  return (
    <EntityProfileCaregiverRelationshipsSection
      owner={{
        type: "Caregiver",
        id: props.caregiverId,
        option:
          props.caregiver === undefined
            ? undefined
            : {
                id: Number(props.caregiver.id),
                displayId: props.caregiver.displayId,
                displayName: getCaregiverFullName(props.caregiver),
              },
      }}
      onOpenRelatedEntity={(relationship) =>
        props.actions.navigateToPatient(getRelatedEntityId(relationship, "patient"))
      }
    />
  );
}
